import ConfirmAuthorizeVvvo, { ConnectedState, ConnectedDispatch } from "./confirm-authorize-vvvo.component";
import { confirmAuthorizeVvvo } from "../../../store/confirm-authorize-vvvo/confirm-authorize-vvvo.actions";
import { getTranslationsStatus } from "../../../store/i18n/i18n.selectors";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import { AppState } from "../../../store/app.state";

const mapDispatchToProps = (dispatch: Dispatch): ConnectedDispatch => ({
  confirmAuthorizeVvvo: (authorizationId: number, token: string) =>
    dispatch(confirmAuthorizeVvvo({ authorizationId, token })),
});

const mapStateToProps = (state: AppState): ConnectedState => ({
  translationsStatus: getTranslationsStatus(state),
});

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmAuthorizeVvvo);
